/**
 *
 * Narzędzia do dynamicznych formularzy.
 *
 * Docelowo powinno tu być kilka angularopodobnych rozwiązań ułatwiających pracę z formularzami.
 *
 */
;
((function ($) {
    'use strict';

    /**
     * Zdalna walidacja
     * ================
     *
     * Gdy dodamy formularzowi atrybut `data-validate="remote"`, będzie validowany AJAX-em.
     * Akcja formularza powinna zwrócić obiekt JSON
     *
     *     {"status":"success"}
     *
     * lub
     *
     *     {
     *         "status":"error",
     *         "fiedsErrors": {
     *             "fieldId1": {
     *                 "errorCode1": "Error message 1",
     *                 "errorCode2": "Error message 2"
     *             },
     *             "fieldId2": {
     *                 "errorCode3": "Error message 3"
     *             }
     *         }
     *     }
     *
     * Wtedy odpowiednim elementom `.form-group` zostaną ustawione klasy
     * `has-error` lub `has-success` oraz dodane zostaną elementy
     *
     *     <span class="help-block">Error message</span>
     *
     * (jako `append` za końcu rodzica elementu formularza).
     *
     * *UWAGA!* Gdy w jednym `.form-group` będą zarówno elementy poprawnie i niepoprawnie
     * zwalidowane, wtedy zostaną dodane obie klasy.
     *
     * Więc skrypt jest generalnie do rozwinięcia.
     *
     */
    $(document).on('submit.veneo.forms', '[data-validate="remote"]', function (event) {

        var
            form = $(this),
            btnSend = form.find('button[type="submit"]');

        event.preventDefault();

        
        btnSend.closest('.form-group')
            .removeClass('has-success')
            .removeClass('has-error')
            .find('.help-block').remove().end();
        
        btnSend.addClass('sending').prop('disabled', true);
         
        $.post(form.attr('action'), form.serialize(), function (response) {

            if (response.status && response.status == 'success') {

                form.find('.has-error').removeClass('has-error');
                form.find('.has-success').removeClass('has-success');
                form.find('.help-block').remove();
                
                btnSend.removeClass('sending').prop('disabled', true);

                $('input, select, textarea').each(function () {

                    var
                        field = $(this),
                        fieldContainer = field.parent(),
                        formGroup = fieldContainer.closest('.form-group');

                });

                btnSend.addClass('sent').html('Wysłano!').prop('disabled', true);
                
                btnSend.closest('.form-group').addClass('has-success');
                btnSend.parent().prepend('<span class="help-block">' + response.info + '</span>');

            } else {

                btnSend.removeClass('sending').prop('disabled', false);

                var firstFieldError  = false;
                var tmp = 
                $('input, select, textarea').each(function () {

                    var
                        field = $(this),
                        fieldId = field.attr('name'),
                        fieldContainer = field.parent(),
                        formGroup = field.closest('.form-group'), fieldErrors, errorKey;

                    formGroup
                        .removeClass('has-success')
                        .removeClass('has-error')
                        .find('.help-block').remove().end();
                    //zastanowic sie nad opytamalizacja radio (nie iterowac dla tych samych name)
                    if (typeof response.fiedsErrors != "undefined") {
                        if (fieldId in response.fiedsErrors) {
                            
                            if (!firstFieldError) {
                                firstFieldError = field;
                            }
                            
                            fieldErrors = response.fiedsErrors[fieldId];
                            formGroup.addClass('has-error');
                            for (errorKey in fieldErrors) {
                                fieldContainer.append('<span class="help-block">' + fieldErrors[errorKey] + '</span>');
                            }
                        } else {
                            formGroup.addClass('has-success');
                        }
                    } 
                    
                });
          
                var recaptchaFocus = false;
                if (firstFieldError && firstFieldError.length > 0) {
                    if (firstFieldError.attr('name') == 'challenge') {
                        recaptchaFocus = true;
                    } else {
                        firstFieldError.focus();
                    }
                } 
  
                var recaptchaResponse = form.find('#recaptcha_response_field');
                if (recaptchaResponse.length && typeof Recaptcha != "undefined" ) { 
                    if (recaptchaFocus) {
                        Recaptcha.reload(); 
                    } else {  
                        Recaptcha.reload_internal('t'); //without focus
                    }
                }
                
                if (typeof response.fiedsErrors == "undefined") {
                    btnSend.closest('.form-group').addClass('has-error');
                    var error_info = 'Wystąpił błąd';
                    if (typeof response.info != "undefined") {
                        error_info = response.info;
                    }
                    btnSend.parent().prepend('<span class="help-block">' + error_info + '</span>');
                }        
                
            }
            
            form.trigger('reflow.veneo');

        }).fail(function() {
            btnSend.removeClass('sending').prop('disabled', false);
            form.find('.has-error').removeClass('has-error');
            form.find('.has-success').removeClass('has-success');
            form.find('.help-block').remove();
            btnSend.closest('.form-group').addClass('has-error');
            var error_info = 'Wystąpił błąd';
            btnSend.parent().prepend('<span class="help-block">' + error_info + '</span>');
        form.trigger('reflow.veneo');
        });
        
        
        form.trigger('reflow.veneo');

    });

})(jQuery));
